import { render, staticRenderFns } from "./campaing.vue?vue&type=template&id=07312547&"
import script from "./campaing.vue?vue&type=script&lang=js&"
export * from "./campaing.vue?vue&type=script&lang=js&"
import style0 from "./campaing.vue?vue&type=style&index=0&id=07312547&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports